/* Top-right menu: click the button to reveal a stack of individual "blob"
   links that pop in and enlarge on hover. Closes on outside click, Escape,
   any link, or a jump to desktop. */
(function () {
  var menu    = document.getElementById('NavMenu');
  var trigger = document.getElementById('MenuTrigger');
  var panel   = document.getElementById('NavPanel');
  if (!menu || !trigger || !panel) return;

  /* Anchor the fixed blob column directly under the button, flush right. */
  function positionPanel() {
    var r = trigger.getBoundingClientRect();
    panel.style.top = (r.bottom + 12) + 'px';
    panel.style.right = (window.innerWidth - r.right) + 'px';
  }

  function open() { positionPanel(); menu.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
  function close() { menu.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
  function toggle() { menu.classList.contains('is-open') ? close() : open(); }

  trigger.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });

  document.addEventListener('click', function (e) {
    if (menu.classList.contains('is-open') && !menu.contains(e.target)) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) close();
  });
  panel.querySelectorAll('.menu-item').forEach(function (a) {
    a.addEventListener('click', close);
  });
  window.addEventListener('resize', function () { if (menu.classList.contains('is-open')) positionPanel(); });
  window.addEventListener('scroll', function () { if (menu.classList.contains('is-open')) positionPanel(); }, { passive: true });
})();


/* Smooth-scroll in-page anchor links (e.g. "Shop the Collection" -> #shop)
   without pushing a #hash onto the URL. */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id.length < 2) return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
